module.exports = __webpack_public_path__ + "img/pic3.51c941a2.png";